import { CreatedInterfaces } from 'interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'issuers';

type UseGetIssuersProps = {
  manual?: boolean;
};

const useGetIssuers = ({ manual = false }: UseGetIssuersProps = {}) => {
  const [{ data, error, loading }, execute] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/issuers`,
    manual
  });

  return {
    issuers: data?.data,
    isLoading: loading,
    isError: error,
    execute
  };
};

export default useGetIssuers;
